
<div class="its-fine-panel">
  <h1>IT'S FINE  </h1>
  <p>ArkMed Management is broken. Please check back later.</p>
  <pre>{{errorMessage}}</pre>
</div>
